import { create } from "zustand";
import { furnituresObjects } from "./furnitures";

function generateUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0; // genera un numero casuale tra 0 e 15
    const v = c === 'x' ? r : (r & 0x3 | 0x8); // sostituisce la 'x' o la 'y' con il valore appropriato
    return v.toString(16);
  });
}

export const useFurnituresStore = create((set, get) => ({
  drawerIsShown: false,
  setDrawerShown: shown => set({ drawerIsShown: shown }),
  furnitures: furnituresObjects,
  itemsVisible: true,
  setGlobalVisibility: (itemsVisible) => set({ itemsVisible }),
  items: [],
  empty: () => set({ items: [] }),
  getItemByName: (itemName) => get().furnitures.filter(({ name }) => name === itemName)[0],
  updateItem: (uid, x, y) => set((state) => ({
    items: [...state.items.map(item =>
      item.uid === uid ? { ...item, x, y } : item
    )]
  })),
  addItem: (object, pos) => set((state) => ({
    items: [
      ...state.items,
      { 
        ...object,
        uid: generateUID(), 
        x: pos ? pos.x : 0, 
        y: pos ? pos.y : 0, 
        zIndex: 0 
      }
    ]
  })),
  removeItem: (uid) => set((state) => ({
    items: state.items.filter(item => item.uid !== uid)
  })),
  incrementZIndex: (uid) => set((state) => ({
    items: state.items.map(item =>
      item.uid === uid ? { ...item, zIndex: item.zIndex + 1 } : item
    )
  })),
  decrementZIndex: (uid) => set((state) => ({
    items: state.items.map(item =>
      item.uid === uid ? { ...item, zIndex: item.zIndex - 1 } : item
    )
  }))
}));